import * as React from "react";
import BaseUI, { IBaseUI } from "src/engine/ui/BaseUI";
import Utils from "src/lib/utils/Utils";
import { Carousel } from "antd";
import IUIItem from "src/engine/interface/IUIItem";
import UIManifest from "src/engine/ui/UIManifest";
import { IPanelContext } from "src/engine/context/PanelContext";
import "./CarouselPC.scss";

interface ICarouselPC extends IBaseUI {
    // 是否无限循环
    infinite?: boolean;
    // 是否自动切换
    autoplay?: boolean;
    // 自动切换速度
    autoplaySpeed?: number;
    // 是否存在面板指示点
    dots?: boolean;
    // 滚动方向 （true为竖向）
    vertical?: boolean;
    // 是否鼠标滚动翻页
    mouseWheel?: boolean;
    // 兼容 最后一屏不充满的情况（全屏滚动）
    polyScreen?: boolean;
    // 数据渲染子组件
    dataChildren?: IUIItem[] | any;
    // 下一个箭头
    nextArrow?: IUIItem[] | any;
    // 上一个箭头
    prevArrow?: IUIItem[] | any;
    // 其他的子组件
    otherChild?: IUIItem[] | any;
    // 是否淡入淡出效果
    fade?: boolean;
    id?: string;
    slidesToShow?: number;
    slidesToScroll?: number;
    cssEase?: string;
    speed?: number;
    pointerEvents?: boolean;
    initialSlide?: number;
    // 控制当前显示第几页的字段 (多个轮播联动的时候需要)
    showWhichSlide?: string;
    // 切换触发时机
    changeSourceTime?: "after" | "before";
    // 是否切换后触发数据
    isChangeItemSource?: boolean;
    isChangeItemSourceBe?: boolean;
    // 触发的数据源
    changeSourceName?: string;
    changeSourceNameBe?: string;
    // 传递数据的key（value：当前页面的index）
    changeSourceKey?: string;
    changeSourceKeyBe?: string;
    // 触发条件的一些设置
    changeSourceIfItem?: any[];
    changeSourceIfItemBe?: any[];
    // 是否切换后触发数据的固定参数
    changeSourceDefaultProps?: any;
    changeSourceDefaultPropsBe?: any;
    // 是否鼠标悬停不暂停
    notPauseOnHover?: boolean;
    // 窗口改变大小后重新计算渲染
    needresize?: boolean;
    // 子组件盒子的最小高度（兼容性能差的浏览器）
    itemboxmH?: string;
    // 是否开启滚屏和自由滚动混合的模式
    mixScrollFlag?: boolean;
    // 混合滚动的屏数
    mixScrollNumber?: number;
    // 自由滚动dom标签
    autoScrolldomTag?: string;
    // 轮播样式
    showType?: string;
    // openZoom 使用zoom 基准值默认是 1080px;
    // 使用时需要打开 resize needresize
    openZoom?: boolean;
    ienormal?: boolean;
    // 是否添加鼠标悬浮的逻辑
    isMouseOver?: boolean;
}

interface IState {
    nowIndex: number;
    style: React.CSSProperties;
    carousel: any;
    source: any;
    showSlide?: number;
    goTo: any;
    resizeFlag: boolean;
    zoom?: number;
    // 鼠标是否悬浮在上边
    mouseOver?: boolean;
}

function limitEvent(eventFn: any) {
    let flag = false;
    return function (...args: any[]) {
        if (flag) return;
        flag = true;
        eventFn(...args);
        return;
    };
}

@UIManifest.declare("CarouselPC", "PC轮播组件(antd)", UIManifest.Type.PC)
class CarouselPC extends BaseUI<ICarouselPC, IState> {
    removeWheelEvent: any;
    removeHoverEvent: any;

    resizeEvent: any;

    boxEl: React.RefObject<HTMLDivElement>;

    carousel: any;

    changeEventOnce: any;

    constructor(props: ICarouselPC) {
        super(props);
        this.boxEl = React.createRef();
        this.carousel = React.createRef();
        const state: IState = {
            nowIndex: 0,
            style: { position: "relative" },
            source: props.dataSource,
            carousel: this.carousel,
            goTo: this.slickGoTo,
            resizeFlag: false,
            mouseOver: false,
        };
        const { showWhichSlide } = props;
        if (showWhichSlide) {
            state.showSlide = Number(Utils.getValue(props, showWhichSlide.split("."))) || 0;
            state.nowIndex = state.showSlide;
        }
        if (props.needresize) {
            if (props.openZoom) {
                state.zoom = this.computeBaseZoom();
                window["resizeChangeZoom"] = true;
            }
            const resizeFn = () => {
                if (!props.openZoom) {
                    this.setState((lstate: IState) => {
                        return { resizeFlag: !lstate.resizeFlag };
                    });
                } else {
                    this.setState({ zoom: this.computeBaseZoom() });
                    setTimeout(() => {
                        this.setState((lstate: IState) => {
                            return { resizeFlag: !lstate.resizeFlag };
                        });
                    }, 16);
                }
            };
            window.addEventListener("resize", resizeFn, false);
            this.resizeEvent = () => {
                window.removeEventListener("resize", resizeFn, false);
            };
        }
        this.state = state;
        this.changeEventOnce = limitEvent(this.changeEvent);
    }

    computeBaseZoom = () => {
        // 基准值是设计尺寸 默认值 1080px;
        let clientHeight = document.documentElement.clientHeight;
        const baseSize = 1080;
        if (!clientHeight) clientHeight = 1080;
        if (clientHeight > baseSize) clientHeight = baseSize;
        return Number((clientHeight / baseSize).toFixed(2)) || 1;
    };

    static getDerivedStateFromProps(nextp: ICarouselPC, lasts: IState) {
        const { showWhichSlide } = nextp;
        const { showSlide, carousel } = lasts;
        const state = {};
        let flag = false;
        if (showWhichSlide) {
            const val = Number(Utils.getValue(nextp, showWhichSlide.split(".")));
            if (showSlide !== val) {
                const carous = carousel.current;
                if (carous) {
                    setTimeout(() => {
                        carous.goTo(val);
                    }, 300);
                    flag = true;
                    state["showSlide"] = val;
                }
            }
        }
        if (nextp.dataSource !== lasts.source) {
            flag = true;
            state["source"] = nextp.dataSource;
        }
        if (flag) {
            return state;
        }
        return lasts;
    }

    componentDidMount() {
        const { mouseWheel } = this.props;
        let style = {};
        const boxEl = this.boxEl.current;
        if (boxEl && boxEl.clientHeight) {
            style = { ...this.state.style, height: `${boxEl.clientHeight}px` };
        }
        this.setState({ style: { ...style } });
        if (this.props.isMouseOver) {
            this.bindHoverEvent();
        }
        if (!mouseWheel) return;
        this.bindWheelEvent();
    }

    bindHoverEvent = () => {
        const boxEl = this.boxEl.current;
        const over = () => {
            this.setState({ mouseOver: true });
        };
        const out = () => {
            this.setState({ mouseOver: false });
        };
        boxEl?.addEventListener("mouseenter", over, false);
        boxEl?.addEventListener("mouseleave", out, false);
        this.removeHoverEvent = () => {
            boxEl?.removeEventListener("mouseenter", over, false);
            boxEl?.removeEventListener("mouseleave", out, false);
        };
    };

    bindWheelEvent = () => {
        if (this.limitBindFlag === true) return;
        this.limitBindFlag = true;
        this.removeWheelEvent = Utils.polyWheelDeltaEvent(this.boxEl.current, (e: any) => {
            if (e.delta < 0) {
                return this.next();
            }
            if (e.delta > 0) {
                return this.prev();
            }
        });
    };

    limitBindFlag: boolean = false;

    removeWheelEventLimit = (fn?: any) => {
        if (this.removeWheelEvent && this.limitBindFlag) {
            this.limitBindFlag = false;
            this.removeWheelEvent();
            if (fn) fn();
        }
    };

    childComponentWillUnmount() {
        this.removeWheelEventLimit();
        if (this.removeHoverEvent) this.removeHoverEvent();
        if (this.resizeEvent) this.resizeEvent();
        if (this.scrollEvent) this.scrollEvent();
    }

    scrollEvent: any;

    scrollEventFlag: boolean = false;

    changeEvent = () => {
        if (this.scrollEventFlag) return;
        this.scrollEventFlag = true;
        const { autoScrolldomTag } = this.props;
        if (!autoScrolldomTag) return;
        const dom: any = document.querySelector(autoScrolldomTag);
        if (!dom) return;
        dom.style.overflow = "auto";
        const scrollEventFn = (e: any) => {
            const top = e.target.scrollTop;
            if (top > 0) {
                this.removeWheelEventLimit();
            }
            if (top === 0) {
                // this.prev();
                if (this.scrollEvent) this.scrollEvent();
                this.bindWheelEvent();
            }
        };
        dom.addEventListener("scroll", scrollEventFn, false);
        this.scrollEvent = () => {
            this.scrollEventFlag = false;
            dom.removeEventListener("scroll", scrollEventFn, false);
        };
    };

    next = () => {
        const carousel = this.carousel.current;
        if (carousel) carousel.next();
    };

    prev = () => {
        const carousel = this.carousel.current;
        if (carousel) carousel.prev();
    };

    slickGoTo = (index: number) => {
        console.log("slickGoTo", index);
        const carousel = this.carousel.current;
        if (carousel) {
            carousel.goTo(index);
        }
    };

    beforeChange = (last: number, next: number) => {
        const { isChangeItemSourceBe } = this.props;
        if (isChangeItemSourceBe) this.changeItemSendSource(next, "before");
        // 修复 满屏滚动自由滚动混合情况下的bug
        if (this.props.mixScrollFlag) {
            if (last === Number(this.props.mixScrollNumber) && !this.scrollEventFlag) {
                const { autoScrolldomTag } = this.props;
                if (autoScrolldomTag) {
                    const scrollDom: any = document.querySelector(autoScrolldomTag);
                    if (scrollDom) scrollDom.style.overflow = "hidden";
                }
            }
        }
        // fullPage组件改变hash不满足要求
        // react-slick组件不能半屏滚动
        // 所以做了如下兼容处理
        if (!this.props.vertical) return;
        if (!this.props.polyScreen) return;
        const boxEl = this.boxEl.current;
        if (!boxEl) return;
        const dom: any = boxEl.querySelector(".slick-track");
        let theight = 0;
        for (let i = 1; i < dom.children.length; i++) {
            theight += dom.children[i].clientHeight;
        }
        if (next + 1 === this.props.children.length) {
            Promise.resolve().then(() => {
                dom.style["WebkitTransform"] = `translate3d(0px, -${theight}px, 0px)`;
                dom.style["transform"] = `translate3d(0px, -${theight}px, 0px)`;
                dom.style["msTransform"] = `translate3d(0px, -${theight}px, 0px)`;
                dom.style.height = "auto";
            });
        }
        return;
    };

    afterChange = (nowIndex: number) => {
        const { isChangeItemSource } = this.props;
        if (isChangeItemSource) this.changeItemSendSource(nowIndex, "after");
        this.setState({
            nowIndex,
        });
        if (this.props.mixScrollFlag) {
            if (nowIndex === Number(this.props.mixScrollNumber)) {
                // this.changeEventOnce();
                this.changeEvent();
            }
        }
    };

    changeItemSendSource = (nowIndex: number, types: string) => {
        const { isChangeItemSourceBe, isChangeItemSource } = this.props;
        let suffix = "";
        if (isChangeItemSourceBe && types === "before") {
            suffix = "Be";
        }
        if (isChangeItemSource && types === "after") {
            suffix = "";
        }
        const sourceName = this.props[`changeSourceName${suffix}`],
            sourceKey = this.props[`changeSourceKey${suffix}`] || "nowIndex",
            sourceIf = this.props[`changeSourceIfItem${suffix}`] || [],
            sourceProp = this.props[`changeSourceDefaultProps${suffix}`] || {};

        if (sourceName && sourceKey) {
            const params = { ...sourceProp, [sourceKey]: nowIndex };
            // 触发数据
            if (sourceIf.length === 0) {
                return this.fireChangeSource(sourceName, params);
            }
            for (const item of sourceIf) {
                const { pagenum, type = "=" } = item;
                if (Utils.compare(type, nowIndex, pagenum)) {
                    return this.fireChangeSource(sourceName, params);
                }
            }
        }
    };

    fireChangeSource = (changeSourceName: string, params: any) => {
        const sourceArray = changeSourceName.split(".");
        for (const source of sourceArray) {
            this.sourceContext.execSource(source, params);
        }
    };

    renderTabs = (context: any) => {
        const { children, dataChildren = [] } = this.props;
        const { nowIndex } = this.state;
        const props = {
            pagemsg: { nowIndex },
            prev: this.prev,
            next: this.next,
        };
        if (!children || children.length === 0) {
            return this.renderDataItems(this.props.dataSource || [], dataChildren[0], context, props);
        } else {
            return children.map((item: IUIItem) => {
                return this.renderChildren([item], props);
            });
        }
    };

    renderDataItems(list: any[] = this.props.data || this.props.dataSource, uiItem: IUIItem, context: IPanelContext, props?: any) {
        if ((list || []).length === 0) return this.renderChildren();
        if (!uiItem) return null;
        if (!Array.isArray(list)) return;
        return list.map((data, key) => {
            if (uiItem) return this.renderUIItem(uiItem, context, { key, index: key, data, ...props, thisIndex: key });
        });
    }

    renderUIItem = (uiItem: IUIItem, context: IPanelContext, props: any = {}) => {
        const boxEl = this.boxEl.current;
        const style: React.CSSProperties = {};
        if (boxEl && boxEl.clientHeight) {
            style.height = `${boxEl.clientHeight}px`;
        }
        if (props.normalRender) {
            return super.renderUIItem(uiItem, context, props);
        }
        const { props: prop } = uiItem;
        if (prop.style && prop.style.height && prop.style.height !== "100%" && prop.style.height !== "window") {
            style.height = `${prop.style.height}`;
        } else {
            if (this.props.ienormal && Utils.isIE()) {
                style.height = `${this.props["ieHeight"]}`;
            }
        }
        if (this.props["itemboxmH"]) {
            style.minHeight = this.props["itemboxmH"];
        }
        return (
            <div key={props.key}>
                <div className="carousel-pc-relative" style={style}>
                    {super.renderUIItem(uiItem, context, props)}
                </div>
            </div>
        );
    };

    renderAct = () => {
        const {
            dots = false,
            infinite = false,
            nextArrow = [],
            prevArrow = [],
            otherChild = [],
            vertical = false,
            autoplay = false,
            autoplaySpeed = 3000,
            id,
            slidesToShow = 1,
            slidesToScroll = 1,
            cssEase,
            speed,
            pointerEvents,
            notPauseOnHover = false,
            showType,
        } = this.props;
        const { nowIndex, source } = this.state;
        const slideCount = source?.length;

        const other: any = {};
        let prevDisabled = false,
            nextDisabled = false;
        if (cssEase) other.cssEase = cssEase;
        if (speed) other.speed = speed;
        if (showType === "centerMode") {
            other.className = "center-mode";
            other.centerMode = true;
        }
        if (autoplay) {
            other.autoplaySpeed = autoplaySpeed;
        }
        if (vertical) {
            other.dotPosition = "right";
        }

        // 判断上/下一步按钮是否可点击
        if (!infinite && (nowIndex === 0 || slideCount <= slidesToShow)) {
            prevDisabled = true;
        }
        if ((other.centerMode && nowIndex >= slideCount - 1) || slideCount <= slidesToShow || nowIndex >= slideCount - slidesToShow) {
            nextDisabled = true;
        }

        const style = this.getStyle();
        if (this.props.openZoom) {
            if (!Utils.isIE()) {
                style["zoom"] = this.state.zoom;
            }
        }

        if (this.props.fade) other.fade = true;

        return this.panel((context) => {
            return (
                <div className={`react-pc-carousel ${pointerEvents ? "auto-pointer" : ""}`} ref={this.boxEl} style={style} id={id}>
                    {this.props.ienormal && Utils.isIE() ? (
                        this.renderTabs(context)
                    ) : (
                        <Carousel
                            infinite={infinite}
                            dots={dots}
                            autoplay={autoplay}
                            beforeChange={this.beforeChange}
                            afterChange={this.afterChange}
                            ref={this.carousel}
                            vertical={vertical}
                            slidesToShow={slidesToShow}
                            pauseOnHover={!notPauseOnHover}
                            slidesToScroll={slidesToScroll}
                            {...other}
                        >
                            {this.renderTabs(context)}
                        </Carousel>
                    )}

                    {otherChild.length > 0
                        ? this.renderChildren(otherChild, {
                              prev: this.prev,
                              next: this.next,
                              goTo: this.slickGoTo,
                              nowIndex,
                              normalRender: true,
                              dataSource: this.props.dataSource,
                              mouseOver: this.state.mouseOver,
                              disabledBtn: { prevDisabled, nextDisabled },
                          })
                        : null}

                    {prevArrow.length > 0 ? this.renderChildren(prevArrow, { onClick: this.prev, nowIndex, normalRender: true, prevArrow }) : null}
                    {nextArrow.length > 0 ? this.renderChildren(nextArrow, { onClick: this.next, nowIndex, normalRender: true, nextDisabled }) : null}
                </div>
            );
        });
    };
}

export default CarouselPC;
